import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'

export {
  Button,
  IconButton,
  CheckBox,
  Typography,
  TextField,
  Heading,
} from '@tmov/design-system'
export { Eye, EyeOff } from '@tmov/design-system/icons'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  overflow: auto;
`
export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`
export const Main = styled.div`
  max-width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  text-align: center;
  b {
    color: ${colors.brand.primary[100]};
  }
`

export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 24px;
  button {
    width: 120px;
  }
`
